import React, { useEffect, useRef } from "react";

/**
 * Embeds the TrustIndex Google Reviews widget in a dedicated homepage section.
 * Script loader is idempotent — safe to mount/unmount multiple times.
 */
const GoogleReviewsBlock = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // TrustIndex main loader
    const scriptId = "trustindex-loader";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://cdn.trustindex.io/loader.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section
      style={{
        padding: "50px 0 30px",
        background: "#ffffff",
      }}
      aria-label="Google customer reviews"
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-30">
          <div
            style={{
              display: "inline-block",
              background: "rgba(66, 133, 244, 0.1)",
              color: "#4285F4",
              padding: "5px 16px",
              borderRadius: "20px",
              fontSize: "0.78rem",
              fontWeight: 700,
              marginBottom: "14px",
              letterSpacing: "0.5px",
            }}
          >
            <i className="fab fa-google mr-2" />
            LIVE GOOGLE REVIEWS
          </div>
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 800,
              color: "#18305d",
              marginBottom: "8px",
            }}
          >
            4.6 ★ from 163+ Verified Google Reviews
          </h2>
          <p
            style={{
              fontSize: "0.95rem",
              color: "#666",
              maxWidth: "560px",
              margin: "0 auto",
              lineHeight: 1.5,
            }}
          >
            Real people. Real reviews. Pulled directly from Google — we don't cherry-pick.
          </p>
        </div>

        {/* TrustIndex widget container */}
        <div ref={containerRef} className="text-center">
          <div
            className="ti-widget"
            data-widget-id="trustindex-auto"
            style={{ minHeight: "60px" }}
          />
        </div>

        {/* Fallback CTA */}
        <div className="text-center" style={{ marginTop: "18px" }}>
          <a
            href="https://www.google.com/search?q=cell+station+willow+grove#lrd=0x89c6b1fc42ab6fef:0x7c78b804e3a9c5ec,3"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 22px",
              background: "#4285F4",
              color: "#ffffff",
              borderRadius: "24px",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "0.9rem",
            }}
          >
            <i className="fab fa-google" />
            View All Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviewsBlock;
